import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const getProjectsOverview = ({ page = 1, limit = 10, search = '' } = {}) =>
  axios.post(`${BASE}/api/v1/ai/admin/projects-overview`, { page, limit, search }, { headers: authHeaders() });

export const getProjectUsageList = (projectPid, page = 1, limit = 20, feature = null) =>
  axios.post(`${BASE}/api/v1/ai/project-usage/list`, { projectPid, page, limit, feature }, { headers: authHeaders() });
